import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth73: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M85.1,117.6h52.9s-19.5,71-52.9,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M25.3,84.9s85.5,14.2,153.5,0l2.5,5.9,1.8,4,.3,8.2-1.7,6.5s-56.7,11-155.2-1.8l-2.2-4.4-1.6-4.3v-9.4c0,0,2.6-4.7,2.6-4.7Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M38.3,121.8l-4.8-4.2-3.6-4.4-3.3-5.4-2.2-4.4-1.6-4.1v-9.6c0,0,2.6-6.6,2.6-6.6l2.1-6.3,4-5.2,2.8-2.2s37.5,18.8,3.9,52.4Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M168.6,70.5l4.5,5.4,3.3,5.2,2.3,3.8,4.3,9.8.3,8.3-1.7,6.5-3.6,8.3-3.9,5.6s-45.2-23.9-5.6-52.9Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.5,92.3s62,32.9,158,0l1.4,2.8v9c.1,0-1.5,6.5-1.5,6.5l-3.9,8.9-8.8,11.6-7.6,8.7-6.9,6.6-7.3,2.9-6.9,4.6-10.2,3.9h-16l-13.2-2.7-13.9-5.6-12.3-5.1-10.9-6.3-11.1-6.6-11.5-7.4-7.9-6.7-4-6.3-3.6-5.8-1.9-6.1.3-6.8Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.5,92.3l1.2-8.4,1.4-7,3.9-5.1,5.1-3.3,7.3-3.5,9.3-5.2,8.5-4,8.7-4.1,4.4-1.8,8.8-5.6,8.9-3.3,5.9-1.6,5.5-1.5h16.7l8.5,3.2,6.1,3.2,7.6,4.5,8,4.9,7.1,4.4,5.2,4.3,4.7,5.2,5.4,5.3,3.1,4,2.8,4.9,2.3,5,1.8,3.3v2.2s-85.9,33.9-158,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M115.7,157.4l-18.2-3.9-24.4-10.5-28.3-16.7c-10.7-6.3-19.4-16.8-21.3-29.4s2.5-23.1,10.2-27.1l24.4-12.5c7.5-3.8,14.6-6.9,21.9-11.1,13.4-7.8,35.1-11.4,49.1-3.2l21.3,12.5c13.9,8.2,28.3,23.6,31.4,39.3,1.6,8,0,17.8-4.9,24.1l-14,18.1c-4.6,5.9-10.5,9.9-17.5,12.5-8.1,6.8-18.8,10.3-29.8,7.9Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '48.4 470.3 60.9 478.4 73.8 486.2 87 494 91.8 496.3 101.8 496.3 114.4 486.7 125.6 476.8 143 459.8 36.5 459.8 40.1 464.1 42.8 466.6 48.4 470.3',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M116.4,398.7A14.6,14.6 0 1 0 87.2,398.7A14.6,14.6 0 1 0 116.4,398.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M171.3,408l.3,9.8-.9,5.8-4.2,8.2-5,7.1s-36.5-30.4,9.7-30.9h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.5,413.1l-1,9.1v7.9l.4,7.1,1.1,7.9.8,2.5s49.1-18.4-1.3-34.4h0Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M47.5,365.6s53.8-30.9,115.8,0l-1.8-10.3s-56.7-30.9-111.7,0c0,0-2.3,10.3-2.3,10.3Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M73.8,486.2l-16.7-9.9-14.4-9.6-6.2-6.9-3-5.3-2.7-7-.8-2.5-1.1-7-.4-7.9v-7.9l1-9.1,2.3-8.7,4.5-11,5.3-11.3,4.4-9s36.8,48.2,27.8,113.1h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M169.2,384.5l1.8,5.7,1.1,6.2.3,6.9v9l-.7,5.6-.9,5.8-4.3,8.4-4.9,6.9-5.4,6.3-6.4,7.1-6.8,7.4-18.5,18-9.8,8.7s-3.1-90.2,54.5-102h0Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M163.3,365.6l1,6.4,4,11,2.3,7.1,1.3,4.5,1,14.9-.5,5.4-1.7,9.4-3.6,7.9-4.8,7.4-5.2,5.2-6.5,7.5-8.1,8.2-11,10.6-7.5,7.2-8.1,6.7-5.8,5.1-7.6,5.9-5.8,1-6.4-1-5.4-2.7-12.1-7.2-14-8.8-13.7-8.3-4.6-4-3.3-3.9-2.8-4.5-2.6-5-1.8-6-.9-2.6-.5-5.1-.5-6.5.2-10.4,2-12,3.8-10,4-8.9,3.8-8.1,4-8.8,1.7-7.4s53.8-31.2,115.8,0v-.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M107,491.9c-12.4,10.8-27-2.7-42.6-12.2l-19.9-12.1c-11.2-8.9-15.7-22.5-15.7-36.5s1-21,5.2-31.1l5-11.9c24.1-33.3,64.1-57.6,100.8-30.6,12.7,9.3,22.6,21.4,30.9,34.8,2.7,15.6,2.4,31.9-7.4,44.3s-21.1,24.6-33.4,35.4l-23,20Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M78.7,85.7h60.1s-26.7,126.7-60.1,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M159.9,58.4l10,12,4.3,9.2,2,8.2.4,7.4s-56.9-17.5-16.7-36.8Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M39,53.5l-2.8,7.1.2,28.1s67.3-21.8,2.6-35.1Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '45.9 38.2 141.9 38.2 112.9 10.6 107.2 7 103.3 5.9 100.2 5.4 95.8 6.2 94 6.8 50.7 32.4 45.9 38.2',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.4,129.7s54.3,63.4,118.2,0l-.9,7.4-.9,7.6s-52.3,53.8-113.8-.4l-2.5-14.6Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M72.3,18.6l-21.6,13.8-4.8,5.8-6.9,15.3-2.8,7.1.2,28.1.8,8.7,5.9,16.7,4.9,9.2s31.2-28.8,24.3-104.7Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M132.5,29.2l9.4,9,18,20.2,10,12,4.5,9.5,1.8,8,.4,7.4v7.8c.1,0-1.2,9.2-1.2,9.2l-3.1,10.5s-41.9-24.7-39.8-93.5Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M51.4,129.7l-3.4-6.5-5.2-9.7-5.7-16.2-.8-8.4-.2-28.3,2.9-7.4,6.8-14.9,4.8-5.8L94,6.8l1.8-.6,4.4-.8,3.6.6,3.4,1,5.7,3.6,29.1,27.6,18.4,20.7,9.5,11.5,4.3,9.2,2,8.2.4,8.2v7c.1,0-1.2,9.2-1.2,9.2l-.2.6-2.9,9.9-2.7,7.1s-57.5,65-118.2,0Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M151.1,150c-16.1,19.2-38.5,29.5-61.3,17.1-20.6-11.2-35.6-33.5-46.6-54.3-3.6-6.9-6-14.3-6.7-22.2-1.7-20.8-1.9-39.2,12.3-55.7s10.3-7.2,15.5-10.5c9.1-5.9,18-11.4,27.7-16.3,14-7,23.3,4.9,34.7,16.1,14.3,12.7,27.2,25.9,38.8,41.1,4.8,5.7,7.4,12,10.1,19.2.2,9.4,2.4,19.9-1.1,29.2-5.2,13.5-14.1,25.3-23.3,36.3Z',
			},
		},
	},
};
